/**
 * Dev :
 * - ERP : https://back-erp.agrosilo-solutions.com/
 * - Logiciel caisse : http://localhost:4100 (backend-logiciel-caisse)
 * Prod : voir environment.prod.ts
 */
const MAIN_ALL_BACKEND = 'https://back-erp.agrosilo-solutions.com/';

/** API Node `back/` (tickets POS, auth caisse, entrep�ts, vendeurs, socket). Port 4100. */
const BACK_LOGICIEL_CAISSE_API = 'https://back-logiciel-caisse.agrosilo-solutions.com/';
/** Front d�di� logiciel caisse (hors Angular vente). */
const LOGICIEL_CAISSE_FRONT_URL = 'https://front-logiciel-caisse.agrosilo-solutions.com/';

export const environment = {
  production: false,
  hmr: false,
  currentModule: 'achat',
  /** Hub partag� : login, inscription, s�lection modules. */
  hubUrl: 'https://front-hub.agrosilo-solutions.com/',
  erpModules: [
    {
      id: 'vente',
      title: 'Vente',
      description: 'Devis, commandes clients, factures, bons de livraison et POS.',
      icon: 'dollar-sign',
      color: '#7367F0',
      baseUrl: 'https://front-vente.agrosilo-solutions.com/',
      defaultRoute: '/dashboards'
    },
    {
      id: 'achat',
      title: 'Achat',
      description: 'Commandes fournisseurs, bons de r�ception et factures achat.',
      icon: 'shopping-cart',
      color: '#00CFE8',
      baseUrl: 'https://front-achat.agrosilo-solutions.com/',
      defaultRoute: '/dashboards',
      authEntryPath: ''
    },
    {
      id: 'remise_promotion',
      title: 'Remise et promotion',
      description: 'Remises, promotions et référentiels partagés (clients, produits).',
      icon: 'tag',
      color: '#9C27B0',
      baseUrl: 'http://localhost:4206',
      defaultRoute: '/dashboards'
    },
    {
      id: 'comptabilite',
      title: 'Comptabilit�',
      description: 'Tr�sorerie, banque, ch�ques et gestion de stock.',
      icon: 'credit-card',
      color: '#28C76F',
      baseUrl: 'https://front-comptabilite.agrosilo-solutions.com/',
      defaultRoute: '/dashboards'
    },
    {
      id: 'parametre',
      title: 'Param�tres',
      description: 'Entreprise, documents, taxes, utilisateurs, caisse et int�grations.',
      icon: 'settings',
      color: '#82868B',
      /** Front d�di� Param�tres */
      baseUrl: 'https://front-parametrage.agrosilo-solutions.com/',
      defaultRoute: '/main/parametre/entreprise'
    },
    {
      id: 'parametre_data',
      title: 'Param�tres donn�es',
      description: 'Configuration des produits, clients, fournisseurs et r�f�rentiels.',
      icon: 'database',
      color: '#FF9F43',
      baseUrl: 'https://front-paramatrage-donne.agrosilo-solutions.com/',
      defaultRoute: '/main/parametre/donnees/produits'
    },
    {
      id: 'gestion_stock',
      title: 'Gestion stock',
      description: 'Stocks, transferts entrepôts, clients, fournisseurs, produits et gammes.',
      icon: 'layers',
      color: '#EA5455',
      baseUrl: 'https://front-gestion-stock.agrosilo-solutions.com',
      defaultRoute: '/gestion-stock/actif'
    }
  ],
  /** Monolithe ERP main-all-backend (users, products, stock, paiements�). */
  apiUrl: MAIN_ALL_BACKEND,
  /** Module clients. */
  client_url: MAIN_ALL_BACKEND,
  /** Module documents (devis, factures, BL�). */
  document_url: MAIN_ALL_BACKEND,
  /** Module fournisseurs. */
  fournisseur_url: MAIN_ALL_BACKEND,
  /** Settings (/api/settings/*). */
  parameters_url: MAIN_ALL_BACKEND,
  /** Param�trage donn�es (/api/parametrage/*). */
  parametrage_url: MAIN_ALL_BACKEND,
  /** Produits. */
  product_url: MAIN_ALL_BACKEND,
  stock_url: MAIN_ALL_BACKEND,
  notifications_url: MAIN_ALL_BACKEND,
  paiement_url: MAIN_ALL_BACKEND,
  tresorerie_url: MAIN_ALL_BACKEND,
  file_url: 'assets/images/',
  /** Pr�fixe des images sous `assets/images/logo/` (ex. discount-2.png, barcode.png). */
  image_url: 'assets/images/logo/',
  /** Base fichiers upload�s (logo, cachet) � backend-erp :4000 */
  url_images: 'https://back-erp.agrosilo-solutions.com',

  // ��� POS / logiciel caisse (`back/` :4100) ���
  /**
   * Base API back caisse pour le POS (`/tiers/ticketCaisse/*`, param�tres caisse, auth admin).
   * Services : LogicielCaisseTicketService, Auth, Entrepots, Vendeurs, etc.
   */
  api_logiciel_caisse: BACK_LOGICIEL_CAISSE_API,
  /**
   * POST /api/stock-transferts + GET /api/entrepots/entrepot/all (m�me back).
   */
  transfertsEntrepotsErpBaseUrl: BACK_LOGICIEL_CAISSE_API,
  /** Application front logiciel caisse (lien externe POS). */
  logiciel_caisse_front_url: LOGICIEL_CAISSE_FRONT_URL,
  /** Code entreprise / station utilis� en dur pour le moment (001 = Kastelo). */
  static_code_entreprise: '001',
};
